// @flow
import {
  SET_CLIENT_INF,
  SET_BUILDING_COUNTERS,
  SET_PAGE_INFO,
} from '../actions/client';

export default function client(state = {}, action) {
  switch(action.type) {
    case SET_CLIENT_INF:
      return {
        ...state,
        info: action.info,
      };
    case SET_BUILDING_COUNTERS:
      return {
        ...state,
        counters: action.counters,
      }
    case SET_PAGE_INFO:
      return {
        ...state,
        pageInfo: action.pageInfo,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client.js